
export default {
  name: 'MoleculeExplore'
}
